export default "__VITE_ASSET__ChQFWxmn__"